module.exports = __webpack_public_path__ + "img/purple2.1ed87204.svg";